"use strict";

const regionsData = require('./data/regions');
const provinciesData = require('./data/provincies');

class Region {
  constructor(codigo) {
    this._codigo = codigo;
  }

  get codigo() {
    return this._codigo;
  }

  /**
   * Obtener el nombre del departamento
   * @return {String}
   */
  getName() {
    const hasOwnRegion = (
      regionsData.hasOwnProperty(this._codigo)
    );

    if (hasOwnRegion === true)  {
      return regionsData[this._codigo];
    } else {
      throw new Error(`El código de la región no existe: ${this._codigo}`);
    }


    return regionsData[this._codigo];
  }

  /**
   * Obtener las provincias del departamento
   * @return {Array[{code, name}]}
   */
  getProvincies() {
    const provincies = Object.keys(provinciesData);

    return provincies.filter((provinceCode) => {
      return provinceCode.substr(0, 2) === this._codigo;
    }).map((provinceCode) => {
      const provinceName = provinciesData[provinceCode];

      return {
        code: provinceCode,
        name: provinceName
      };
    });
  }
}

module.exports = Region;
